import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPermission } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import {
    map,
    shareReplay,
} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PermissionService extends ODataService<IPermission, number> {
    protected _endpoint = '/odata/Permissions';

    constructor(http: HttpClient) {
        super(http, MapperService.permissionMap);
    }

    public getPermissions = () =>
        super.get().pipe(
            map(r => r.data.filter(p => p.name.includes('.'))),
            shareReplay(1),
        )

}
